import { render } from "./SimpleElement.vue?vue&type=template&id=f2a225e6&ts=true"
import script from "./SimpleElement.vue?vue&type=script&lang=ts"
export * from "./SimpleElement.vue?vue&type=script&lang=ts"

import "./SimpleElement.vue?vue&type=style&index=0&id=f2a225e6&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QItemLabel});
